import React from "react";
import { Modal, Table } from "antd";
import { formatDateTime } from "../../utils/formatDateTime";
import {
  RopeDetailModalKeyClass,
  RopeDetailModalKeyWidth,
  RopeDetailModalWidth,
  RopeUpload
} from "../../types/Rope";
import { Link } from "react-router-dom";

type RopeUploadRecordModalProps = {
  modalState: boolean;
  closeModal: () => void;
  record: RopeUpload | null;
};

const RopeUploadRecordModal = (props: RopeUploadRecordModalProps) => {
  const columns = [
    {
      title: "Detail",
      key: "k",
      className: RopeDetailModalKeyClass,
      dataIndex: "k",
      width: RopeDetailModalKeyWidth
    },
    {
      title: "Text",
      key: "v",
      render: (text, row) => {
        switch (row.k) {
          case "Uploaded By":
            return row.v && props.record ? (
              <Link to={`/employees/${props.record.created_by_id}`}>
                {row.v}
              </Link>
            ) : (
              ""
            );
          case "Imported By":
            return row.v && props.record ? (
              <Link to={`/employees/${props.record.updated_by_id}`}>
                {row.v}
              </Link>
            ) : (
              ""
            );
          case "Uploaded At":
          case "Imported At":
            return row.v ? formatDateTime(row.v) : "";
          default:
            return row.v;
        }
      }
    }
  ];
  let data = [{}];
  if (props.record) {
    data = [
      {
        k: "Rope Upload ID",
        v: props.record.id
      },
      { k: "Uploaded At", v: props.record.created_at },
      { k: "Uploaded By", v: props.record.created_by },
      { k: "Original Filename", v: props.record.original_filename },
      { k: "File Version", v: props.record.file_version },
      { k: "Imported At", v: props.record.updated_at },
      { k: "Imported By", v: props.record.updated_by },
      { k: "Comment", v: props.record.comment },
      { k: "Version", v: props.record.version },
      { k: "Status", v: props.record.status },
      { k: "Message Count", v: props.record.message_count }
    ];
  }

  return (
    <Modal
      title={"View Rope Upload Record"}
      visible={props.modalState}
      onCancel={props.closeModal}
      footer={null}
      width={RopeDetailModalWidth}
    >
      <Table
        pagination={false}
        showHeader={false}
        columns={columns}
        dataSource={data}
        rowKey="k"
      />
    </Modal>
  );
};
export default RopeUploadRecordModal;
